import { render, staticRenderFns } from "./ModifierGroupCreate.vue?vue&type=template&id=84bd07f4&scoped=true"
import script from "./ModifierGroupCreate.vue?vue&type=script&lang=js"
export * from "./ModifierGroupCreate.vue?vue&type=script&lang=js"
import style0 from "./ModifierGroupCreate.vue?vue&type=style&index=0&id=84bd07f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bd07f4",
  null
  
)

export default component.exports